import axios from 'axios'

const API_URL = '/api/images/'

// Get Drywall projects
const getDrywall = async () => {
	const response = await axios.get(API_URL + 'getDrywall')

	return response.data
}

const drywallService = { getDrywall }

export default drywallService
